<template>
    <div style="position: relative">
        <CheckoutHeader/>
        <Menu/>
        <MenuOverlay/>
        <BasketProgress/>
        <div class="page js-page page--checkout u-t-center">
            <CheckoutMainFlow/>
            <CheckoutProgress/>
        </div>
        <CheckoutFooter/>
    </div>
</template>

<script>
import Stripe from '../components/Stripe';
import Menu from '../components/Menu';
import MenuOverlay from '../components/MenuOverlay';
import BasketProgress from '../components/BasketProgress';
import CheckoutMainFlow from '../components/CheckoutMainFlow';
import CheckoutFooter from '../components/CheckoutFooter';
import CheckoutHeader from '../components/CheckoutHeader';
import CheckoutProgress from '../components/CheckoutProgress';

export default {
    name:"Checkout",
    components: {
        Stripe,
        Menu,
        MenuOverlay,
        BasketProgress,
        CheckoutMainFlow,
        CheckoutHeader,
        CheckoutProgress,
        CheckoutFooter
    },
    computed: {
        stage() {
            return this.$store.state.checkout.stage;
        }
    }
}
</script>

<style lang="scss">
@import '../assets/scss/main.scss';

/*  @media (min-width: 1200px) {
     .container{
        max-width: 650px;
    }
 } 
*/
</style>
